export const guestServices = () => {
  let installPrompt: any;
  const header = document.querySelector<HTMLElement>("header");
  const guestServiceSnackbar = document.querySelector("[js-snackbar-gs]");
  const guestServiceBookmark = document.querySelector("[js-bookmark-page]");

  if (!guestServiceSnackbar || !guestServiceBookmark || !header) {
    return;
  }

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    installPrompt = event;
    guestServiceSnackbar.removeAttribute("hidden");

    const viewportOffset = guestServiceSnackbar.getBoundingClientRect();

    const top = viewportOffset.bottom > 0 ? viewportOffset.bottom : 0;
    header.style.top = top.toString() + "px";

    guestServiceBookmark.addEventListener("click", async () => {
      if (installPrompt !== null) {
        installPrompt.prompt();
        const { outcome } = await installPrompt.userChoice;
        if (outcome === "accepted") {
          installPrompt = null;
        }
      }
    });
  });

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/dist/js/serviceWorker.js");
  }
};
